import { ExperimentsExtension } from '@wix/premium-fed-sdk-kit/@extensions';
export const EclipseExperimentsExtension = ExperimentsExtension({
  scope: ['premium-purchase-plan', 'premium-package-pickers']
});
//# sourceMappingURL=eclipse-experiments.extension.js.map